export default {
  mesh: 'Mesh',
  logout: 'Déconnexion',
  notifications: 'Notifications',
  'help-center': "Centre d'aide",
  header: {
    myCollabs: 'Mes collabs',
    summary: 'Récap',
    activityManagement: "Gestion d'activité"
  },
  nomenclature: {
    allStore: 'Tout le magasin',
    levels: {
      allUniverses: 'Tous les univers',
      univers: 'Univers',
      department: 'Rayon Inter. | Rayon Inter. | Rayons Inter.',
      market: 'Marché | Marché | Marchés',
      category: 'Catégorie | Catégorie | Catégories',
      family: 'Famille | Famille | Familles'
    }
  },
  collaborators: {
    addCollaborator: 'Ajouter un collaborateur',
    isExisting: 'Tu as déjà ajouté ce collaborateur',
    someCollaborators: 'Plusieurs collabs',
    assignCollaborator: 'Assigné un collab'
  },
  responsability: {
    univers: ctx => `J'ai${ctx.named('partial') ? ', en partie,' : ''} la reponsabilité de cet univers`,
    department: ctx => `J'ai${ctx.named('partial') ? ', en partie,' : ''} la reponsabilité de ce rayon inter.`,
    market: ctx => `J'ai${ctx.named('partial') ? ', en partie,' : ''} la reponsabilité de ce marché`,
    category: ctx => `J'ai${ctx.named('partial') ? ', en partie,' : ''} la reponsabilité de cette catégorie`,
    family: ctx => `J'ai${ctx.named('partial') ? ', en partie,' : ''} la reponsabilité de cette famille`
  },
  activities: {
    SOME: 'Plusieurs activités',
    ALL: 'Toute la gérance',
    outofstock: 'Ruptures',
    pilot: 'Pilotage',
    stick: 'Pingouin Sticks',
    command: 'Prépa cmd'
  },
  print: 'Imprimer',
  saved: 'Sauvegardé',
  loginTo: 'Se connecter à '
}
